// assets/product-option-size.js
(function () {
  document.addEventListener("DOMContentLoaded", init);

  function init() {
    // 1) inject CSS for disabled options
    var css = ".style-select .ss-option.disabled {   }";
    var styleEl = document.createElement("style");
    styleEl.type = "text/css";
    styleEl.appendChild(document.createTextNode(css));
    document.head.appendChild(styleEl);

    // 2) grab elements
    var bandSel = document.getElementById("option2");
    var cupSel = document.getElementById("option3");
    var hiddenSel = document.querySelector('select.js-hidden-id[name="id"]');
    var productInput = document.querySelector('input[name="product-id"]');
    if (
      !bandSel ||
      !cupSel ||
      !hiddenSel ||
      !productInput ||
      typeof styleSelect !== "function"
    )
      return;
    // Wait for variant data to be available
    // Embed variant data directly

    if (!window.currentProductVariants) {
      window.currentProductVariants = null;
      // Convert to our expected format
      var formatted = {};
      Object.values(window.currentProductVariants).forEach(function (variant) {
        formatted[variant.id] = {
          id: variant.id,
          available: variant.available,
          option1: variant.option1,
          option2: variant.option2,
          option3: variant.option3,
          price: variant.price,
        };
      });
      window.currentProductVariants = formatted;
    }
    console.log(
      "Variant data loaded:",
      Object.keys(window.currentProductVariants).length,
      "variants"
    );
    // 3) hide native selects
    // bandSel.style.display = "none";
    // cupSel.style.display = "none";

    // 4) placeholders
    var bandPlaceholder = "Band Size";
    var cupPlaceholder = "Cup Size";

    // 5) remove old widgets, build new ones + bind click to update label immediately
    [bandSel, cupSel].forEach(function (sel, idx) {
      // remove any existing style-select
      while (
        sel.nextElementSibling &&
        sel.nextElementSibling.classList.contains("style-select")
      ) {
        sel.nextElementSibling.remove();
      }
      // build
      styleSelect(sel);

      // find its display and options
      var widget = sel.nextElementSibling;
      var display = widget.querySelector(".ss-selected-option");
      var opts = widget.querySelectorAll(".ss-option");
      // set initial placeholder
      display.textContent = idx === 0 ? bandPlaceholder : cupPlaceholder;

      // bind to each option so first click updates display text
      opts.forEach(function (opt) {
        if (opt.classList.contains("disabled")) return;
        opt.addEventListener("click", function () {
          var newLabel = opt.textContent.trim();
          display.textContent = newLabel;
          display.dataset.value = opt.dataset.value;
          sel.value = opt.dataset.value; // Update the actual select value
        });
      });
    });

    // 6) disable cup options when band changes
    function updateDisabledCups() {
      var currentBand = bandSel.value;

      if (!window.currentProductVariants) {
        console.error("No variant data available");
        return;
      }

      var disabled = [];
      Object.values(window.currentProductVariants).forEach(function (variant) {
        if (!variant.available && variant.option2 === currentBand) {
          disabled.push(variant.option3);
        }
      });

      var cupWidget = cupSel.nextElementSibling;
      cupWidget.querySelectorAll(".ss-option").forEach(function (el) {
        if (disabled.includes(el.dataset.value)) {
          el.classList.add("disabled");
        } else {
          el.classList.remove("disabled");
        }
      });
    }

    // 7) find matching variant id using Shopify data only
    function findVariantId(bandValue, cupValue) {
      if (!window.currentProductVariants) {
        console.error("No variant data available");
        return null;
      }

      var found = Object.values(window.currentProductVariants).find(function (
        variant
      ) {
        return (
          variant.option2 === bandValue &&
          variant.option3 === cupValue &&
          variant.available
        );
      });

      return found ? found.id.toString() : null;
    }

    // 8) sync hidden select, input, URL, and manage buttons
    function sync() {
      var b = bandSel.value;
      var c = cupSel.value;

      console.log("Sync called with:", { band: b, cup: c });

      var bandText = bandSel.nextElementSibling
        .querySelector(".ss-selected-option")
        .textContent.trim();
      var cupText = cupSel.nextElementSibling
        .querySelector(".ss-selected-option")
        .textContent.trim();

      // Select ALL add to bag buttons and waitlist buttons
      var addBtns = document.querySelectorAll(".js-add-to-bag, #btnAddToBag");
      var waitBtns = document.querySelectorAll("#btnModal");

      console.log("Display text:", { bandText: bandText, cupText: cupText });
      console.log("Placeholders:", {
        bandPlaceholder: bandPlaceholder,
        cupPlaceholder: cupPlaceholder,
      });

      // If either is still placeholder, disable AddToBag and hide waitlist
      if (bandText === bandPlaceholder || cupText === cupPlaceholder) {
        addBtns.forEach(function (btn) {
          btn.disabled = true;
          btn.classList.remove("hide");
        });
        waitBtns.forEach(function (btn) {
          btn.classList.add("hide");
        });
        return;
      }

      // Both have real values now
      addBtns.forEach(function (btn) {
        btn.disabled = false;
      });

      // Check if selected cup option is disabled
      var cupWidget = cupSel.nextElementSibling;
      var selectedCupOption = cupWidget.querySelector(".ss-option.ticked");
      if (
        selectedCupOption &&
        selectedCupOption.classList.contains("disabled")
      ) {
        addBtns.forEach(function (btn) {
          btn.classList.add("hide");
        });
        waitBtns.forEach(function (btn) {
          btn.classList.remove("hide");
          btn.style.removeProperty("display");
        });
        return;
      }

      var productHandle = productInput.closest("form").dataset.productHandle;
      if (!productHandle) {
        // Fallback: try to get from form action or other attributes
        var form = productInput.closest("form");
        productHandle =
          form.action.split("/").pop() ||
          Object.keys(window.productVariants || {})[0];
      }

      var vid = findVariantId(b, c);
      console.log("Found variant ID:", vid);

      if (!vid) {
        addBtns.forEach(function (btn) {
          btn.classList.add("hide");
        });
        waitBtns.forEach(function (btn) {
          btn.classList.remove("hide");
          btn.style.removeProperty("display");
        });
        return;
      }

      // We have a valid variant
      addBtns.forEach(function (btn) {
        btn.classList.remove("hide");
      });
      waitBtns.forEach(function (btn) {
        btn.classList.add("hide");
      });

      // Sync hidden select, URL, etc.
      if (hiddenSel.value !== vid) {
        hiddenSel.value = vid;
        hiddenSel.dispatchEvent(new Event("change", { bubbles: true }));
      }
      productInput.value = vid;
      var u = new URL(window.location);
      u.searchParams.set("variant", vid);
      window.history.replaceState(null, "", u);

      updateDisabledCups();
    }

    // 9) events
    bandSel.addEventListener("change", function () {
      updateDisabledCups();
      sync();
    });
    cupSel.addEventListener("change", sync);
    document.body.addEventListener("click", function (e) {
      if (
        e.target.closest(".ss-option") &&
        !e.target.classList.contains("disabled")
      ) {
        // When the user clicks a non-disabled option, wait for label to update, then sync
        setTimeout(sync, 0);
      }
    });

    // 10) initial state
    updateDisabledCups();
    sync();
  }
})();